// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P2Dk4","footer":"styles_footer__1Jbk3"};